import { faro } from '@grafana/faro-web-sdk';
import { createErrorService } from './ErrorService.impl';

export const myErrorService = createErrorService({
  captureException: (error, hint) => {
    faro.api?.pushError(error, { context: hint.tags });
  }
});
